export default __webpack_public_path__ + "30f1fb7ccd33e528eaf80bad5bc2f0a8.jpg";